<template>
	<div>
		<statistics-partials-plain partial-title="Fairway Chances" :partial-value="roundFairways.fairway_chances"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairway Hit" :partial-value="roundFairways.fairways_hit"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairway%" :partial-value="roundFairways.fairways_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed" :partial-value="roundFairways.fairways_missed"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed%" :partial-value="roundFairways.fairways_missed_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Left" :partial-value="roundFairways.fairways_missed_left"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Left%" :partial-value="roundFairways.fairways_missed_left_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Long" :partial-value="roundFairways.fairways_missed_long"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Long%" :partial-value="roundFairways.fairways_missed_long_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Right" :partial-value="roundFairways.fairways_missed_right"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Right%" :partial-value="roundFairways.fairways_missed_right_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Short" :partial-value="roundFairways.fairways_missed_short"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Short%" :partial-value="roundFairways.fairways_missed_short_percentage"></statistics-partials-plain>
		<statistics-partials-plain partial-title="Fairways Missed Unknown" :partial-value="roundFairways.fairways_missed_unknown"></statistics-partials-plain>

	</div>
</template>
<script>
export default {
	name: "StatisticsFairways",
	props: {
		roundFairways: {
			type: Object,
			required: true
		}
	},
	components: {
		'statistics-partials-plain': () => import(/* webpackChunkName: "StatisticsPlain" */ './Partials/Plain'),
	}
}
</script>
